import React from 'react';
import { observer } from 'mobx-react-lite';
import { useInjection } from 'services/ioc/ioc.react';
import { TaggingStore } from 'stores/Tagging/TaggingStore';
import { ServiceTypes } from 'constants/ServiceTypes';
import { Button, Modal } from '@trackman/web-shared-components';
import { Content, ContentWrapper, Controls } from './AdvanceBatterModalStyles';

interface IProps {
  onDismissCallback: () => void;
}

const AdvanceBatterModal: React.FC<IProps> = observer(({ onDismissCallback }) => {
  const taggingStore = useInjection<TaggingStore>(ServiceTypes.TaggingStore);
  const { playStore } = taggingStore;

  const handleOnYesClick = (): void => {
    playStore.overrideBatterAdvancementForNextPlay = false;
    onDismissCallback();
  };
  const handleOnNoClick = (): void => {
    playStore.overrideBatterAdvancementForNextPlay = true;
    onDismissCallback();
  };

  return (
    <Modal title='Advance batter?' open onClose={onDismissCallback} titleCenter>
      <ContentWrapper>
        <Content>Do you want to advance batter?</Content>
        <Controls>
          <Button intent='primary' label='No' onClick={handleOnNoClick} />
          <Button intent='primary' label='Yes' onClick={handleOnYesClick} />
        </Controls>
      </ContentWrapper>
    </Modal>
  );
});

export default AdvanceBatterModal;
